import { Grid } from '@material-ui/core';
import { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect } from 'react-redux';
import Truncate from 'react-truncate';
import {
  fetchPlaylists,
  updatePlaylistDataAfterFetch
} from '../../../../redux/actions/app-actions';
import { firebase } from '../../../../firebase';
import placeholderTile from '../../../../images/tile-bg-inflo-generic-01.png';
import ImageLoader from '../../../../components/ImageLoader';
import SearchBarWrapper from '../../../../components/SearchBarWrapper';
import PodcastSkeletonLoader from '../../../../components/ui/skeleton/PodcastSkeletonLoader';
import Toast from '../../../../components/Toast';
import Playlist from './Playlist';

class PlaylistsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loader: false,
      sorting: 'asc',
      playlists: [],
      showPlaylistModal: false,
      searchPl: false,
      showModal: false,
      playlist: null,
      error: null
    };

    this.search = this.search.bind(this);
  }

  componentWillUnmount() {
  this._isMounted = false;
  clearTimeout(this.interval);
}

  errorHandler = (err) => {
    this.setState({ error: err });

    this.interval = setTimeout(() => {
      if (this.state.error) this.setState({ error: null });
    }, 3000);
  };

 onUpdatePlaylists = (token) => {
  fetchPlaylists(token).then((res) => {
    const { data } = res;
    this.props.dispatch(updatePlaylistDataAfterFetch(res));
    data.forEach((d) => {
      if (!d.imgUrl) d.imgUrl = placeholderTile;
    });
    if (this._isMounted) this.setState({ playlists: data }); // ← guard here
  });
};

 componentDidMount() {
  this._isMounted = true;
  if (firebase.auth.currentUser) {
    firebase.auth.currentUser.getIdToken().then((token) => {
      this.onUpdatePlaylists(token);
    });
  }
}

  searchBarPl = () => {
    // clear search onClose
    if (this.state.searchPl) {
      this.setState({ playlists: this.props.playlists });
    }

    this.setState((prevState) => ({
      searchPl: !prevState.searchPl
    }));
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  search = (searchValue) => {
    if (!searchValue) {
      this.setState({ playlists: this.props.playlists });
      return;
    }

    const filteredPlaylists = this.props.playlists.filter((playlist) => {
      const name = playlist.name.toLowerCase();
      const query = searchValue.toLowerCase();
      return (
        name.startsWith(query) || name.includes(query) || name.endsWith(query)
      );
    });

    this.setState({ playlists: filteredPlaylists });
  };

  setPlaylistHandler = (playlist) => {
    this.setState({
      playlist
    });
  };

  removePlaylistHandler = () => {
    this.setState({
      playlist: null
    });
  };

  render() {
    let playlists = this.state.playlists;

    return (
      <div className="square-container">
        {this.state.error && (
          <Toast
            type="danger"
            error={this.state.error}
            handleDismiss={() => this.errorHandler(null)}
          />
        )}
        {this.state.loader && (
          <Grid container spacing={3} wrap="wrap">
            {Array.from({ length: 20 }, (_, i) => (
              <Grid key={i} item>
                <PodcastSkeletonLoader />
              </Grid>
            ))}
          </Grid>
        )}
        {!this.state.loader && (
          <>
            {this.state.playlist ? (
              <Playlist
                playlist={this.state.playlist}
                goBack={this.removePlaylistHandler}
                onPlayDocument={this.props.onPlayDocument}
                playingDocumentId={this.props.playingDocumentId}
                documentDeleted={this.props.documentDeleted}
                onDocumentDeleted={this.props.onDocumentDeleted}
              />
            ) : (
              <>
                <SearchBarWrapper
                  onError={this.errorHandler}
                  onChange={this.search}
                  onCreateNew={this.onUpdatePlaylists}
                  searchBar={this.searchBarPl}
                  addNew={true}
                  searchUi={this.state.searchPl}
                  showCreatePlaylistModal={this.state.showModal}
                  showModal={this.showModal}
                  hideModal={this.hideModal}
                >
                  {' '}
                </SearchBarWrapper>
                {playlists && (
                  <div className="divider-line">
                    <span className="cat-name">My Playlists</span>{' '}
                  </div>
                )}
                {(playlists || []).map((p) => (
                  <div
                    className="img-slider"
                    key={p.id}
                    onClick={() => this.setPlaylistHandler(p)}
                  >
                    <ImageLoader
                      id={p.id}
                      src={p.imgUrl}
                      width="120px"
                      height="120px"
                    />
                    <div className="podcast-name">
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={<Popover id="popover-basic">{p.name}</Popover>}
                      >
                        <Truncate lines={1} ellipsis={'...'} width={120}>
                          {p.name}
                        </Truncate>
                      </OverlayTrigger>
                    </div>
                  </div>
                ))}
              </>
            )}
          </>
        )}
      </div>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    playlists: store.app.playlists,
    playingDocumentId: store.app.playingDocumentId
  };
};
export default connect(mapStateToProps)(PlaylistsTab);
